import AdjustmentActivityList from './AdjustmentActivityList';

export default AdjustmentActivityList;
